<script setup lang="ts">
import { onBeforeUnmount, ref, watch } from 'vue'
import type { Track } from 'livekit-client'

const props = defineProps<{ track: Track; mirror?: boolean; fit?: 'cover' | 'contain' }>()
const el = ref<HTMLVideoElement | null>(null)

watch(
  [() => props.track, el],
  ([t, v], [oldT]) => {
    if (oldT && oldT !== t) oldT.detach()
    if (t && v) t.attach(v)
  },
  { immediate: true },
)
onBeforeUnmount(() => {
  if (el.value) props.track.detach(el.value)
})
</script>

<template>
  <video
    ref="el"
    autoplay
    playsinline
    muted
    class="h-full w-full"
    :class="[fit === 'contain' ? 'object-contain' : 'object-cover', mirror ? '-scale-x-100' : '']"
    data-testid="call-video"
  />
</template>
